import { render, staticRenderFns } from "./DdaTemplateList.vue?vue&type=template&id=b5725542&scoped=true"
import script from "./DdaTemplateList.vue?vue&type=script&lang=js"
export * from "./DdaTemplateList.vue?vue&type=script&lang=js"
import style0 from "./DdaTemplateList.vue?vue&type=style&index=0&id=b5725542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5725542",
  null
  
)

export default component.exports